// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qdc1RbEno740HVEY {
  position: fixed;
  left: clamp(30px, 3vw, 10px);
  top: clamp(70px, 40vh, 390px);
}

.Qdc1RbEno740HVEY div:first-child.GgeGL5WfKn82fYJr {
  animation-play-state: running;
}

.Qdc1RbEno740HVEY div:first-child {
  background-color: #ffffff;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 9px;
  animation-name: IarCzN6i40ZT4VM8;
  animation-duration: 2s;
  animation-timing-function: ease-in;
  animation-play-state: paused;
}

@keyframes IarCzN6i40ZT4VM8 {
  0% {
    background-color: #ffffff;
    color: #000000;
  }
  1% {
    background-color: #ff0000;
    color: #ffffff;
  }
  100% {
    background-color: #ffffff;
    color: #000000;
  }
}

.tGNhWpENAZgiQ2AC {
  display: flex;
}

.tnS_4WifRAsp_pmN {
  margin-right: 15px;
}

.tnS_4WifRAsp_pmN button {
  background-color: #20336c;
  font-size: 16px;
  padding: 12px 32px;
  border-radius: 16px;
}

.tnS_4WifRAsp_pmN button:last-child {
  margin-left: 10px;
  background-color: transparent;
  color: #20336c;
  border: 2px solid #20336c;
  padding: 11px 31px;
}

.Le7V2pHajekQNq9B {
  display: flex;
  justify-content: center;
}

.muJuh0Nh_vURzSSQ {
  background-color: #339c49;
  color: #ffffff;
}

.PZ4MqXj1WvUfFz67 {
  @media print {
    font-size: 10px !important;
  }
}

.PZ4MqXj1WvUfFz67 .p-datatable-table {
  @media print {
    font-size: 10px !important;
  }
}

.QAXrxWwFzdMz1gAU {
  display: flex;
  width: 45%;
}

.QAXrxWwFzdMz1gAU > div:first-child {
  margin-right: 10px;
}

.i3adL67ETycY4Du7 {
  display: flex;
  gap: 26px;
  flex-wrap: wrap;
  width: 100%;
}

.Q3n03ml5uSIe4poi {
  width: clamp(90%, 90vw, 1920px);
  margin: 0 auto;
}

.Q3n03ml5uSIe4poi h2 {
  text-align: center;
  font-weight: 500;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0;
  text-transform: capitalize;
  color: #303030;
}

.kQ77Ce7HDa0ifh7e {
  border-radius: 25px;
  overflow: hidden;
}

.kQ77Ce7HDa0ifh7e .p-dialog-header,
.kQ77Ce7HDa0ifh7e .p-dialog-content {
  background-color: #f3f5f7;
}

.XwKN1pmOhofOKAoL {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.XwKN1pmOhofOKAoL > div {
  font-size: 24px;
  font-weight: 800;
  color: #000000;
}

.XwKN1pmOhofOKAoL button {
  margin-right: 20px;
  background-color: transparent;
  border: 1px solid #20336c;
  color: #20336c;
  border-radius: 16px;
}

.yOOSagU295UgPZex {
  border: none !important;
  box-shadow: none;
  color: #20336c;
  font-size: 14px;
  font-weight: 700;
}

.PZ4MqXj1WvUfFz67 {
  border-top: 1px solid #acacac;
  padding-top: 18px;
}

.HD7ueJuxLT4ClWR0 {
  text-align: center;
  font-size: 24px;
  font-weight: 800;
  color: #20336c;
  margin: 0 0 20px 0;
}

.uJgAd7CsqN8N9kPE {
  width: 100%;
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 16px;
}

.moMNE29X0M8L3ckg {
  background-color: #f9f9f9;
  padding: 18px 32px;
  border-radius: 16px;
  height: 99px;
  width: 100%;
}

.moMNE29X0M8L3ckg > div:last-child {
  font-size: 36px;
  font-weight: bold;
  color: #20336c;
  margin-top: 12px;
}

.ITW0XGHMgVYSZwYz {
  display: flex;
  justify-content: space-between;
}

.ITW0XGHMgVYSZwYz > div:first-child {
  font-size: 16px;
  font-weight: bold;
  color: #303030;
}

.ITW0XGHMgVYSZwYz > div:last-child {
  font-size: 14px;
  font-weight: 300;
  font-style: italic;
  color: #303030;
}

.ejhefkxoxISInwbj .p-datatable-thead th {
  background-color: #c6d4e1;
  border: 1px solid #ffffff;
}

.ejhefkxoxISInwbj .p-datatable-tbody td {
  border: 1px solid #f3f5f7;
}

.wgaShgAw0EsFhe1S {
  width: 575px;
  border-radius: 0 25px 25px 0;
  padding: 35px;
  background-color: #f3f5f7;
  color: #000000;
}

.pHaUMqmpD28Rz4Ok {
  padding-top: 34px;
}

.pHaUMqmpD28Rz4Ok .p-accordion-tab:first-child {
  border-top: 1px solid #acacac;
}

.pHaUMqmpD28Rz4Ok .p-accordion-tab {
  border-bottom: 1px solid #acacac;
  padding-top: 34px;
  padding-bottom: 34px;
}

.pHaUMqmpD28Rz4Ok .p-accordion-header {
  font-size: 20px;
}

.pHaUMqmpD28Rz4Ok
  .p-accordion .p-accordion-header .p-accordion-header-link {
  border: none;
  background-color: transparent;
}

.pHaUMqmpD28Rz4Ok .p-accordion .p-accordion-content {
  background-color: transparent;
  border: none;
  padding-left: 30px;
  color: #000000;
}

.YXNiH2N6q8MRUlNO {
  display: flex;
  align-items: center;
}

.YXNiH2N6q8MRUlNO > div:nth-child(1) {
  width: 50px;
}

.YXNiH2N6q8MRUlNO > div:nth-child(2) {
  width: 175px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chef/Station.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAiC;EACjC,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd","sourcesContent":[".indicator {\r\n  position: fixed;\r\n  left: clamp(30px, 3vw, 10px);\r\n  top: clamp(70px, 40vh, 390px);\r\n}\r\n\r\n.indicator div:first-child.playAnimation {\r\n  animation-play-state: running;\r\n}\r\n\r\n.indicator div:first-child {\r\n  background-color: #ffffff;\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  margin-bottom: 9px;\r\n  animation-name: newOrderIndicator;\r\n  animation-duration: 2s;\r\n  animation-timing-function: ease-in;\r\n  animation-play-state: paused;\r\n}\r\n\r\n@keyframes newOrderIndicator {\r\n  0% {\r\n    background-color: #ffffff;\r\n    color: #000000;\r\n  }\r\n  1% {\r\n    background-color: #ff0000;\r\n    color: #ffffff;\r\n  }\r\n  100% {\r\n    background-color: #ffffff;\r\n    color: #000000;\r\n  }\r\n}\r\n\r\n.controlsWrapper {\r\n  display: flex;\r\n}\r\n\r\n.countsButton {\r\n  margin-right: 15px;\r\n}\r\n\r\n.countsButton button {\r\n  background-color: #20336c;\r\n  font-size: 16px;\r\n  padding: 12px 32px;\r\n  border-radius: 16px;\r\n}\r\n\r\n.countsButton button:last-child {\r\n  margin-left: 10px;\r\n  background-color: transparent;\r\n  color: #20336c;\r\n  border: 2px solid #20336c;\r\n  padding: 11px 31px;\r\n}\r\n\r\n.startButtonWrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.startButton {\r\n  background-color: #339c49;\r\n  color: #ffffff;\r\n}\r\n\r\n.statList {\r\n  @media print {\r\n    font-size: 10px !important;\r\n  }\r\n}\r\n\r\n.statList :global(.p-datatable-table) {\r\n  @media print {\r\n    font-size: 10px !important;\r\n  }\r\n}\r\n\r\n.statFieldWrapper {\r\n  display: flex;\r\n  width: 45%;\r\n}\r\n\r\n.statFieldWrapper > div:first-child {\r\n  margin-right: 10px;\r\n}\r\n\r\n.orders {\r\n  display: flex;\r\n  gap: 26px;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n}\r\n\r\n.ordersWrapper {\r\n  width: clamp(90%, 90vw, 1920px);\r\n  margin: 0 auto;\r\n}\r\n\r\n.ordersWrapper h2 {\r\n  text-align: center;\r\n  font-weight: 500;\r\n  font-size: 20px;\r\n  line-height: 100%;\r\n  letter-spacing: 0;\r\n  text-transform: capitalize;\r\n  color: #303030;\r\n}\r\n\r\n.statModal {\r\n  border-radius: 25px;\r\n  overflow: hidden;\r\n}\r\n\r\n.statModal :global(.p-dialog-header),\r\n.statModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.statHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.statHeader > div {\r\n  font-size: 24px;\r\n  font-weight: 800;\r\n  color: #000000;\r\n}\r\n\r\n.statHeader button {\r\n  margin-right: 20px;\r\n  background-color: transparent;\r\n  border: 1px solid #20336c;\r\n  color: #20336c;\r\n  border-radius: 16px;\r\n}\r\n\r\n.sendToEmailBtn {\r\n  border: none !important;\r\n  box-shadow: none;\r\n  color: #20336c;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n}\r\n\r\n.statList {\r\n  border-top: 1px solid #acacac;\r\n  padding-top: 18px;\r\n}\r\n\r\n.statStationName {\r\n  text-align: center;\r\n  font-size: 24px;\r\n  font-weight: 800;\r\n  color: #20336c;\r\n  margin: 0 0 20px 0;\r\n}\r\n\r\n.statFieldsWrapper {\r\n  width: 100%;\r\n  display: flex;\r\n  gap: 16px;\r\n  justify-content: center;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.statFieldItem {\r\n  background-color: #f9f9f9;\r\n  padding: 18px 32px;\r\n  border-radius: 16px;\r\n  height: 99px;\r\n  width: 100%;\r\n}\r\n\r\n.statFieldItem > div:last-child {\r\n  font-size: 36px;\r\n  font-weight: bold;\r\n  color: #20336c;\r\n  margin-top: 12px;\r\n}\r\n\r\n.statFieldItemHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.statFieldItemHeader > div:first-child {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  color: #303030;\r\n}\r\n\r\n.statFieldItemHeader > div:last-child {\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n  font-style: italic;\r\n  color: #303030;\r\n}\r\n\r\n.statTable :global(.p-datatable-thead) th {\r\n  background-color: #c6d4e1;\r\n  border: 1px solid #ffffff;\r\n}\r\n\r\n.statTable :global(.p-datatable-tbody) td {\r\n  border: 1px solid #f3f5f7;\r\n}\r\n\r\n.sidebar {\r\n  width: 575px;\r\n  border-radius: 0 25px 25px 0;\r\n  padding: 35px;\r\n  background-color: #f3f5f7;\r\n  color: #000000;\r\n}\r\n\r\n.sidebarContent {\r\n  padding-top: 34px;\r\n}\r\n\r\n.sidebarContent :global(.p-accordion-tab):first-child {\r\n  border-top: 1px solid #acacac;\r\n}\r\n\r\n.sidebarContent :global(.p-accordion-tab) {\r\n  border-bottom: 1px solid #acacac;\r\n  padding-top: 34px;\r\n  padding-bottom: 34px;\r\n}\r\n\r\n.sidebarContent :global(.p-accordion-header) {\r\n  font-size: 20px;\r\n}\r\n\r\n.sidebarContent\r\n  :global(.p-accordion .p-accordion-header .p-accordion-header-link) {\r\n  border: none;\r\n  background-color: transparent;\r\n}\r\n\r\n.sidebarContent :global(.p-accordion .p-accordion-content) {\r\n  background-color: transparent;\r\n  border: none;\r\n  padding-left: 30px;\r\n  color: #000000;\r\n}\r\n\r\n.itemRow {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.itemRow > div:nth-child(1) {\r\n  width: 50px;\r\n}\r\n\r\n.itemRow > div:nth-child(2) {\r\n  width: 175px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var indicator = `Qdc1RbEno740HVEY`;
export var playAnimation = `GgeGL5WfKn82fYJr`;
export var newOrderIndicator = `IarCzN6i40ZT4VM8`;
export var controlsWrapper = `tGNhWpENAZgiQ2AC`;
export var countsButton = `tnS_4WifRAsp_pmN`;
export var startButtonWrapper = `Le7V2pHajekQNq9B`;
export var startButton = `muJuh0Nh_vURzSSQ`;
export var statList = `PZ4MqXj1WvUfFz67`;
export var statFieldWrapper = `QAXrxWwFzdMz1gAU`;
export var orders = `i3adL67ETycY4Du7`;
export var ordersWrapper = `Q3n03ml5uSIe4poi`;
export var statModal = `kQ77Ce7HDa0ifh7e`;
export var statHeader = `XwKN1pmOhofOKAoL`;
export var sendToEmailBtn = `yOOSagU295UgPZex`;
export var statStationName = `HD7ueJuxLT4ClWR0`;
export var statFieldsWrapper = `uJgAd7CsqN8N9kPE`;
export var statFieldItem = `moMNE29X0M8L3ckg`;
export var statFieldItemHeader = `ITW0XGHMgVYSZwYz`;
export var statTable = `ejhefkxoxISInwbj`;
export var sidebar = `wgaShgAw0EsFhe1S`;
export var sidebarContent = `pHaUMqmpD28Rz4Ok`;
export var itemRow = `YXNiH2N6q8MRUlNO`;
export default ___CSS_LOADER_EXPORT___;
